<div class="d-none" [class.d-block]="!showMobileHeader">
  <app-main-header
    [user]="user"
    [siteItem]="siteItem"
    [profileDetails]="profileDetails"
  ></app-main-header>
</div>
<div class="d-none" [class.d-block]="showMobileHeader">
  <app-mobile-header
    [user]="user"
    [itemList]="siteItem"
    [profileDetails]="profileDetails"
  ></app-mobile-header>
</div>
